module.exports = __webpack_public_path__ + "assets/nominalamount.06e56830.svg";